import React from "react";
import { Badge as NBBadge, IBadgeProps } from "native-base";

interface BadgeProps extends IBadgeProps {
    hidden?: boolean
}

export const Badge: React.FC<BadgeProps> = React.memo((props) => {
    const { hidden, ...badgeProps } = props;
    if (hidden) {
        return null;
    }

    return <NBBadge { ...badgeProps } />
})


interface CountBadgeProps extends BadgeProps {
    count: number;
}

export const CountBadge: React.FC<CountBadgeProps> = React.memo(({count, hidden, ...props}) => {
    return <Badge
        hidden={hidden ?? count === 0}
        position="absolute"
        zIndex={1}
        right={-3}
        top={-3}
        borderWidth={0}
        children={count}
        rounded="full"
        variant="subtle"
        colorScheme="muted"
        alignSelf="flex-end"
        boxSize={4}
        px={1}
        py={0}
        _text={{
            fontSize: 8,
            lineHeight: 16
        }}
        {...props}
    />
})